import { unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/image/search.svg';
var _withScopeId = function _withScopeId(n) {
  return _pushScopeId("data-v-35343fa5"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = /*#__PURE__*/_withScopeId(function () {
  return /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  }, null, -1);
});
var __default__ = {
  name: 'SearchInput'
};
import { useMatomo } from '@shining3d/matomo';
import { XlButton, XlInput } from '@shining3d/ui-components';
import { useLang } from '../../../hooks/lang';
export default /*#__PURE__*/Object.assign(__default__, {
  props: {
    modelValue: {
      type: String || Number,
      default: ''
    }
  },
  emits: ['search', 'update:modelValue'],
  setup: function setup(__props, _ref) {
    var emits = _ref.emit;
    var props = __props;
    var matomo = useMatomo();
    var _toRefs = toRefs(props),
      modelValue = _toRefs.modelValue;
    var value = computed({
      get: function get() {
        return modelValue.value;
      },
      set: function set(val) {
        emits('update:modelValue', val);
      }
    });
    var _useLang = useLang(),
      $t = _useLang.$t;
    var emitSearch = function emitSearch() {
      if (!value.value) {
        return;
      }
      emits('search', value.value);
      matomo.log('click', '支持与下载|搜索|搜索', '使用支持与下载搜索');
    };
    return function (_ctx, _cache) {
      return _openBlock(), _createBlock(_unref(XlInput), {
        class: "searchInput",
        modelValue: _unref(value),
        "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(value) ? value.value = $event : null;
        }),
        placeholder: _unref($t)('searchPlaceholder'),
        onKeyup: _withKeys(emitSearch, ["enter"])
      }, {
        append: _withCtx(function () {
          return [_createVNode(_unref(XlButton), {
            type: "primary",
            size: "small",
            class: "searchButton",
            onClick: emitSearch
          }, {
            default: _withCtx(function () {
              return [_hoisted_1];
            }),
            _: 1
          })];
        }),
        _: 1
      }, 8, ["modelValue", "placeholder", "onKeyup"]);
    };
  }
});